import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M7.782 4.4c.301 0 .545.245.545.546v.981a.545.545 0 0 1-1.09 0v-.436H5.708v5.018h.437a.546.546 0 1 1 0 1.091H4.182a.546.546 0 0 1 0-1.09h.436V5.49H3.091v.437a.545.545 0 0 1-1.091 0v-.981c0-.301.245-.546.546-.546h5.236ZM9.11 7.358a.655.655 0 1 1-.256 1.285.655.655 0 0 1 .255-1.285Zm2.181 0a.657.657 0 0 1 .515.515.655.655 0 1 1-.515-.515Zm2.183 0a.655.655 0 1 1-.256 1.285.655.655 0 0 1 .256-1.285Z';
const draw24px =
  'M13.454 5.488a.643.643 0 0 1 .454.182.62.62 0 0 1 .185.446V8.27a.624.624 0 0 1-.188.444.645.645 0 0 1-.903 0 .623.623 0 0 1-.188-.444v-1.5H8.69v10.487h1.961c.17 0 .332.066.452.183a.624.624 0 0 1 0 .89.645.645 0 0 1-.452.183h-5.2A.645.645 0 0 1 5 18.328a.624.624 0 0 1 .451-1.072h1.96V6.77H3.278v1.499a.623.623 0 0 1-.187.444.645.645 0 0 1-.904 0A.623.623 0 0 1 2 8.269V6.116c0-.166.068-.325.188-.443a.646.646 0 0 1 .452-.185h10.814Z M13.622 10.86a1.165 1.165 0 0 1 .848 1.585 1.163 1.163 0 1 1-.848-1.586Zm3.721 0a1.165 1.165 0 0 1 .42 2.107 1.164 1.164 0 0 1-1.81-.967 1.163 1.163 0 0 1 1.39-1.14Zm3.721 0a1.163 1.163 0 1 1-.455 2.28 1.163 1.163 0 0 1 .455-2.28Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TruncateIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'truncate'),
) as IconWithRender;

TruncateIcon.displayName = 'TruncateIcon';
TruncateIcon.propTypes = Icon.propTypes;
TruncateIcon.renderIcon = (props) => <TruncateIcon {...props} />;
export default TruncateIcon;
